<template>
  <div class="col preview-item border-bottom py-2">
    <div class="col-1 preview-thumbnail align-items-center justify-content-center d-flex">
      <div class="preview-icon">
        <i class="text-primary" :class="imgClass"></i>
      </div>
    </div>
    <div class="col-11 preview-item-content d-sm-flex flex-grow">
      <div class="flex-grow">
        <h6 class="preview-subject">{{ title }}</h6>
        <p class="text-muted mb-0">{{ subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoxFeature',
  props: ['imgClass', 'colorClass', 'title', 'subtitle'],
};
</script>

<style></style>
